import React, {useState, useEffect, useRef} from "react";
import OwlCarousel from 'react-owl-carousel2';
import sanityClient from "@sanity/client";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './tipsAndAdviceWidget.module.css';
import { buildImageObj, cn, getBlogUrl } from "../lib/helpers";
import { imageUrlFor } from "../lib/image-url";
import { gsap, TweenMax, Expo } from "gsap";

let background1 = require('../images/article-1.png').default;
let background2 = require('../images/article-2.png').default;
let background3 = require('../images/article-3.png').default;

let owlClass = "listing-owl hideFirst " + styles.listingWrap;

const options = {
    items: 3,
    nav: false,
    dots: false,
    rewind: false,
    autoplay: false,
    margin: 17,
    responsive : {
        0 : {
            items: 1,
            stagePadding: 30
        },
        900 : {
            items: 3,
            stagePadding: 0
        }
    }
};


function TipsAndAdviceWidget(props) {

    const client = sanityClient(clientConfig.sanity);
    const [posts, setPosts] = useState([]);

    const sectionRef = useRef();
    const titleRef = useRef();
    const subheadingRef = useRef();

    useEffect(() => {
        client
        .fetch(
            `*[_type == "post"][0..2]{
                title,
                excerpt,
                slug,
                mainImage
            }`
        )
        .then((data) => {
            setPosts(data)
            // TweenMax.set([sectionRef.current], {
            //     opacity: 0,
            //     y: 80
            // });
            // if(!$(sectionRef.current).hasClass('anim-complete')){
            //     $(window).on('scroll', () => {
                    
            //         if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){

            //             TweenMax.to(
            //                 sectionRef.current, 
            //                 0.45, 
            //                 { 
            //                     opacity: 1, 
            //                     y: 0, 
            //                     delay : 0,
            //                     onComplete : () => {
            //                         $(sectionRef.current).addClass('anim-complete');
            //                     }
            //                 } 
            //             );
            //         }
            //     });
            // } else {
            //     TweenMax.set([sectionRef.current], {
            //         opacity: 1,
            //         y: 0
            //     });
            // }
        })
        .catch(console.error)

        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

    }, []);
    
    let bgColor = (props.bgcolor) ? props.bgcolor.hex : '#FFFFFF';

    if(posts.length){

        return (
            <div className={styles.sectionTipsAndAdviceWidget} style={{ backgroundColor: `${bgColor}`}} ref={sectionRef}>
                <div className={styles.sectionContent}>
                    <h3 ref={titleRef}>{props.heading}</h3>
                    <div className={styles.richtext} ref={subheadingRef}>
                        <PortableText blocks={props.content} />
                    </div>
                    <div className={styles.listWrapper}>
                    
                        {
                            posts.map((item, i) => {  

                                let post_url = getBlogUrl(item.slug.current);
                                let post_image = '';
                                let itemClass = styles.itemWrap+" stagger-item";

                                item.key = 'pkey-'+i;

                                if(item.mainImage){
                                    post_image = (item.mainImage.asset) ? imageUrlFor(buildImageObj(item.mainImage)) : '';
                                }

                                if(item.slug){
                                    
                                    return (
                                        <a href={post_url} className={itemClass} key={i}>
                                            <div href={post_url} className={styles.imageWrap}>
                                                <img src={post_image} alt={item.title} />
                                            </div>
                                            <div className={styles.contentTextWrap}>
                                                <div className={styles.contentTitle}>
                                                    {item.title}
                                                </div>
                                                <div className={styles.description}>
                                                    <PortableText blocks={item.excerpt} />
                                                </div>
                                            </div>
                                        </a>
                                    )
                                }
                            })
                        }

                    </div>

                    
                    {
                        (props.ctalink) ? 
                            <div className={styles.sectionCTA}>
                                <a href={props.ctalink} className={styles.ctalink}>
                                    <span>{props.ctalabel}</span>
                                </a>
                            </div>
                        : ``
                    }

                </div>
            </div>
        );

    } else {
        return (
            <div className={styles.sectionTipsAndAdviceWidget} style={{ backgroundColor: `${bgColor}`}}></div>
        );
    }
}
  
export default TipsAndAdviceWidget;